import React, {Component} from 'react';
import {withStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/es/Typography/Typography";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";

const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(900 + theme.spacing.unit * 3 * 2)]: {
      width: 900,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[200],
  },
  cardActions: {
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing.unit * 2,
    },
  },
  card: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  media: {
    width: 160,
    height: 120,
  },
});


class Home extends Component {

  constructor(props) {
    super(props);
  }

  followLink = (newUrl) => {
    alert(newUrl)
  };

  render() {
    const {classes} = this.props;
    return (
      <div className='home'>
        <div className={classes.layout}>
          <Typography variant="h6">Frankkie.NL</Typography>
          <br/>

          <Card className={classes.card}>
            <CardActionArea href="/3dprint" className={classes.card}>
              <CardMedia
                className={classes.media}
                image="/images/3d_printing.jpg"
                title="3D printing"/>

              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  3D printing
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  3D prining makes it possible to print items made of plastic. Multiple colors are possible!
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
          <br/>

          <Card className={classes.card}>
            <CardActionArea href="http://frankkie.nl/pony" className={classes.card}>
              <CardMedia
                className={classes.media}
                image="/images/ponk.jpg"
                title="Ponies"/>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Ponies
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  How big is a Pony? Nobody knows! They seem to come in all sizes.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
          <br/>

          <Card className={classes.card}>
            <CardMedia
              className={classes.media}
              image="/images/phone.jpg"
              title="Apps"/>
            <div>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Apps
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Let's check out some smartphone apps!
                </Typography>
              </CardContent>
            </div>
          </Card>
          <br/>

          <Card className={classes.card}>
            <CardMedia
              className={classes.media}
              image="/images/pirates.jpg"
              title="3D printing"/>
            <div>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Pirates
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Yar har fiddle dee dee! Let's party with the pirates.
                </Typography>
              </CardContent>
            </div>
          </Card>
          <br/>

          <Card className={classes.card}>
            <CardMedia
              className={classes.media}
              image="/images/cider.jpg"
              title="Cider"/>
            <div>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Cider
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Let's have a sip of the most magical drink!
                </Typography>
              </CardContent>
            </div>
          </Card>
          <br/>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Home);
